import React, { memo, useMemo } from 'react';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useAppSelector } from 'store/hooks';
import { isUnlocked } from 'utils';
import { selectHasSetupFraudDetection } from 'features/quests/store/selectors';
import ActiveFraudDetectionCard from './ActiveFraudDetectionCard';
import FreeTierFraudDetectionCard from './FreeTierFraudDetectionCard';
const FraudDetectionCard = () => {
    const userTier = useAppSelector(selectUserTier);
    const hasSetupFraudDetection = useAppSelector(selectHasSetupFraudDetection);
    const isFraudDetectionUnlocked = useMemo(() => isUnlocked(userTier, Tier.plus), [userTier]);
    return isFraudDetectionUnlocked && hasSetupFraudDetection ? (<ActiveFraudDetectionCard />) : (<FreeTierFraudDetectionCard />);
};
export default memo(FraudDetectionCard);
